import React from 'react';
import { KPIBucket } from '../../data/types';
import { TrendBadge } from './TrendBadge';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
interface KPICardProps {
  kpi: KPIBucket;
  role: 'hr' | 'management';
}
export function KPICard({
  kpi,
  role
}: KPICardProps) {
  const navigate = useNavigate();
  // Inverse logic for negative KPIs like Burnout
  const isInverse = kpi.name.includes('Burnout') || kpi.name.includes('Workload');
  return <motion.div whileHover={{
    y: -4
  }} onClick={() => role === 'hr' && navigate(`/hr/kpi/${kpi.id}`)} className="glass-card p-5 rounded-xl cursor-pointer relative overflow-hidden group" data-id="element-120">
      <div className="flex justify-between items-start mb-4" data-id="element-121">
        <h3 className="text-secondary text-sm font-medium truncate pr-4" data-id="element-122">
          {kpi.name}
        </h3>
        <TrendBadge trend={kpi.trend} inverse={isInverse} data-id="element-123" />
      </div>

      <div className="flex items-baseline space-x-2" data-id="element-124">
        <span className="text-3xl font-bold text-white" data-id="element-125">{kpi.score}</span>
        <span className="text-xs text-secondary" data-id="element-126">/ 100</span>
      </div>

      {/* Mini Sparkline Placeholder */}
      <div className="mt-4 flex items-end space-x-1 h-8 opacity-50 group-hover:opacity-80 transition-opacity" data-id="element-127">
        {[...Array(10)].map((_, i) => <div key={i} className="flex-1 bg-accent/30 rounded-t-sm" style={{
        height: `${Math.random() * 100}%`
      }} data-id="element-128" />)}
      </div>

      {/* Hover Glow */}
      <div className="absolute -right-10 -bottom-10 w-32 h-32 bg-accent/5 rounded-full blur-3xl group-hover:bg-accent/10 transition-colors" data-id="element-129" />
    </motion.div>;
}